<form nz-form [formGroup]="form" (ngSubmit)="onFormSubmit()">
	<app-text-field
		[label]="COURSE_CSV_LABELS[CourseCsvKeys.ssoCourseId]"
		[controlName]="CourseCsvKeys.ssoCourseId"
		[placeholder]="COURSE_CSV_LABELS[CourseCsvKeys.ssoCourseId]"
		[required]="form.get(CourseCsvKeys.ssoCourseId)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-language-dropdown-field
		[label]="COURSE_CSV_LABELS[CourseCsvKeys.defaultLangId]"
		[controlName]="CourseCsvKeys.defaultLangId"
		[placeholder]="COURSE_CSV_LABELS[CourseCsvKeys.defaultLangId]"
		[required]="form.get(CourseCsvKeys.defaultLangId)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-integer-field
		[label]="COURSE_CSV_LABELS[CourseCsvKeys.displayOrder]"
		[controlName]="CourseCsvKeys.displayOrder"
		[placeholder]="COURSE_CSV_LABELS[CourseCsvKeys.displayOrder]"
		[required]="form.get(CourseCsvKeys.displayOrder)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-rubric-code-dropdown-field
		[label]="COURSE_CSV_LABELS[CourseCsvKeys.rubricCode]"
		[controlName]="CourseCsvKeys.rubricCode"
		[placeholder]="COURSE_CSV_LABELS[CourseCsvKeys.rubricCode]"
		[required]="form.get(CourseCsvKeys.rubricCode)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-product-name-dropdown-field
		[label]="COURSE_CSV_LABELS[CourseCsvKeys.productName]"
		[controlName]="CourseCsvKeys.productName"
		[placeholder]="COURSE_CSV_LABELS[CourseCsvKeys.productName]"
		[required]="form.get(CourseCsvKeys.productName)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-text-field
		[label]="COURSE_CSV_LABELS[CourseCsvKeys.enName]"
		[controlName]="CourseCsvKeys.enName"
		[placeholder]="COURSE_CSV_LABELS[CourseCsvKeys.enName]"
		[required]="form.get(CourseCsvKeys.enName)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-text-field
		[label]="COURSE_CSV_LABELS[CourseCsvKeys.enDescriptionShort]"
		[controlName]="CourseCsvKeys.enDescriptionShort"
		[placeholder]="COURSE_CSV_LABELS[CourseCsvKeys.enDescriptionShort]"
		[required]="form.get(CourseCsvKeys.enDescriptionShort)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-textarea-field
		[label]="COURSE_CSV_LABELS[CourseCsvKeys.enDescriptionHtml]"
		[controlName]="CourseCsvKeys.enDescriptionHtml"
		[placeholder]="COURSE_CSV_LABELS[CourseCsvKeys.enDescriptionHtml]"
		[required]="form.get(CourseCsvKeys.enDescriptionHtml)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-checkbox-field
		[label]="COURSE_CSV_LABELS[CourseCsvKeys.active]"
		[controlName]="CourseCsvKeys.active"
		[formGroup]="form"
	/>

	<nz-form-item>
		<nz-form-control [nzOffset]="7" [nzSpan]="12">
			<div class="buttons">
				<button nz-button nzType="primary" [disabled]="loading() || form.invalid">
					Submit
					@if (loading()) {
						<nz-spin nzSimple nzSize="small"></nz-spin>
					}
				</button>
				<button nz-button (click)="onClearClicked()">Clear</button>
			</div>
		</nz-form-control>
	</nz-form-item>
</form>
